import 'react-app-polyfill/ie11';
import 'intersection-observer';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { LocalizeProvider } from "react-localize-redux";
import * as serviceWorker from './serviceWorker';
import App from './components/App.js';

ReactDOM.render(
  <LocalizeProvider>
    <Router>
      <App />
    </Router>
  </LocalizeProvider>
  , document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
